import queryString from 'query-string';

import { FEVER_API_ENDPOINT, NEW_FEVER_HOST } from 'config/envVariable';
import { fetchOpts, newFetchOpts } from './common';
import { mergePromoSettingInFormData } from 'api/editor';
import { FORM_STATUS } from 'config/const';

export async function initClientForm(id, formVersion) {
    if (formVersion === 0) {
        return getOldFormClientData(id);
    } else {
        return getNewFormClientData(id);
    }
}

function getNewFormClientData(formId) {
    const testQs = getTestQueryString();
    const { mode } = queryString.parse(window.location.search);
    const isPreviewMode = (Boolean(mode) && mode === 'preview') || Boolean(testQs);
    let queryPreview = '';
    let payload = {};
    if (isPreviewMode) {
        queryPreview = '?mode=preview';
    }
    return fetch(
        `${FEVER_API_ENDPOINT}/forms/${formId}${queryPreview}`,
        newFetchOpts({ ...payload })
    )
        .then(res => res.json())
        .then(mergePromoSettingInFormData);
}

function getOldFormClientData(formId) {
    const { test, mode } = queryString.parse(window.location.search);
    let queryPreview = '';
    let payload = {};
    if (mode && mode === 'preview') {
        queryPreview = '?mode=preview';
    } else if (test) {
        const encodeTest = encodeURIComponent(test);
        payload.mode = encodeTest;
    }
    return fetch(
        `${FEVER_API_ENDPOINT}/form/${formId}${queryPreview}`,
        fetchOpts({ method: 'GET', ...payload })
    )
        .then(res => res.json())
        .then(mergePromoSettingInFormData);
}

export function postForm(id, values, recaptchaToken, token) {
    const { test, mode } = queryString.parse(window.location.search);
    const body = JSON.stringify(values);
    let queryPreview = '';
    const payload = {};
    if (test) {
        const encodeTest = encodeURIComponent(test);
        payload.mode = encodeTest;
    } else if (mode && mode === 'preview') {
        queryPreview = '?mode=preview';
    }
    return fetch(
        `${FEVER_API_ENDPOINT}/form/${id}/submit${queryPreview}`,
        fetchOpts({ method: 'POST', body, recaptchaToken, token, ...payload })
    ).then(res => res.json());
}

function getTestQueryString() {
    const { test_code, test_expired } = queryString.parse(window.location.search);
    return test_code && test_expired
        ? { 'preview-code': test_code, 'expired-at': test_expired }
        : null;
}

export function newPostForm(formId, payload, recaptchaToken, formStatus) {
    const testQs = getTestQueryString();
    const qs =
        FORM_STATUS.PUBLISH !== formStatus && testQs ? `?${queryString.stringify(testQs)}` : '';
    return fetch(`${FEVER_API_ENDPOINT}/forms/${formId}/submit${qs}`, {
        method: 'POST',
        headers: new Headers({
            'Fever-Host': NEW_FEVER_HOST,
            Accept: `application/x.api.v1+json`,
            'Content-Type': 'application/json; charset=utf-8',
            recaptchaToken
        }),
        body: JSON.stringify(payload)
    }).then(res => res.json());
}

export function clientUploadFile(file) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const body = formData;
    const fetchOptions = fetchOpts({ method: 'POST', body });
    fetchOptions.headers.delete('Content-Type');
    return fetch(`${FEVER_API_ENDPOINT}/uploads`, fetchOptions).then(res => res.json());
}
